@if (type!=='donut' && type!=='horizontal_rectangle') {
  <div class="myknob-component" [class]="classList">
    <svg [attr.width]="size" [attr.height]="size" class="u-progress" aria-hidden="true"
      [attr.viewBox]="'0 0 ' + viewBox + ' ' + viewBox">
      <!-- Circle type-->
      @if (type==='circle') {
        <circle cx="60" cy="60" [attr.r]="r" fill="none" class="u-progress-bg" stroke-width="10">
        </circle>
      }
      @if (type==='circle') {
        <circle cx="60" cy="60" [attr.r]="r" fill="none" stroke-linecap="round"
          class="u-progress-status" stroke-dasharray="339.292" stroke-width="10"
        [style.stroke-dashoffset]="percentToShow"></circle>
      }
      <!-- Vertical rectangle type-->
      @if (type==='vertical_rectangle') {
        <rect x="10" y="30" width="100" height="1" rx="4" ry="4" fill="none"
          class="u-progress-bg" stroke-width="8" />
      }
      @if (type==='vertical_rectangle') {
        <rect x="10" y="30" [attr.width]="percent" height="1" rx="4" ry="4"
          fill="none" class="u-progress-status" stroke-width="8" />
      }
    </svg>
    <div class="myknob-component-caption">
      <div class="column" [class]="contentContainerStyleClass">
        <ng-content select="[body]"></ng-content>
        <span class="myknob-component-caption-percent">
          <ng-content select="[knob-content]"></ng-content>
        </span>
      </div>
      @if (useComponentInside) {
        <div>
          <ng-container *ngTemplateOutlet="inside"></ng-container>
        </div>
      }
    </div>
  </div>
}
<ng-content select="[any-content]"></ng-content>

@if (type==='donut') {
  <div>
    <canvas #doughnutKnob [attr.width]="data.width" [attr.height]="data.height" class="cursor-pointer"
    (click)="doughnutKnobOnClick.emit('')"></canvas>
  </div>
}


<!-- Horizontal rectangle type-->
@if (type==='horizontal_rectangle') {
  <div class="myknob-component" [class]="classList">
    <!--    <div class="row" style="width: 80%;">
    <span>0</span>
    <span>1000</span>
  </div> -->
  <svg class="u-progress" aria-hidden="true" style="transform: rotate(0deg);height: 35px;width:100px">
    <rect x="0" y="3" height="35" fill="rgba(46,217,195,.1)" style="width:100px" />
    <rect x="0" y="3" height="35" fill="#2ed9c3" [style]="horizontalRectangleStyle" />
    <text x="50%" y="15" text-anchor="middle" alignment-baseline="middle" font-family="Assistant, sans-serif"
      class="fz-12 bold">
      {{percent}}%
    </text>
    <text x="50%" y="28" text-anchor="middle" alignment-baseline="middle" font-family="Assistant, sans-serif"
      class="fz-10">
      {{totalValue}}
    </text>
  </svg>
</div>
}